// Import the edliy_utils
import {
    makeResponsive,
    placeTitle,
    placeImage,
    placeInput,
    placeSlider,
    hoverMe,
    placeRec,
    hiddenPt,
    fixedPt,
    clearInputFields,
    dragMe,
    placeArrow,
    placeGravity,
    placeMiddleText,
    placeLine,
    placePoint,
    placeGlider,
    placeRuler,
    placeLeftText,
    placeRightText,
    placeSliderSwitch,
    placeCircle,
    placeLogo,
    placeShuffle,
    placeTest
} from '../../../common/edliy_utils-fractions';
const Boxes = {
  box1: function () {
	JXG.Options.board.minimizeReflow = 'none';
  JXG.Options.point.showInfoBox=false;
  JXG.Options.point.highlight=false;
  JXG.Options.image.highlight=false;
  JXG.Options.text.highlight=false;
  JXG.Options.text.fixed=true;
  JXG.Options.curve.highlight=false;
  JXG.Options.text.cssDefaultStyle='fontFamily:Oswald;'
  var brd1 = JXG.JSXGraph.initBoard('jxgbox1',{boundingbox: [-8, 8, 8, -8],keepaspectratio: true, axis:false, ticks:true, grid:true, showCopyright:false, showNavigation:false, pan:{enabled:false}, zoom:{enabled:false}});
  //brd1.suspendUpdate();
  makeResponsive(brd1);
  brd1.options.layer['image'] =12;
  brd1.options.layer['circle'] =13;
  brd1.options.layer['chart'] =14;
  brd1.options.layer['sector'] =15;
  brd1.options.layer['line'] =15;
//	brd1.create('text', [6, 11.5, 'Fraction'],{highlight:false, display:'internal', anchorX:'middle', anchorY:'middle', CssStyle:'fontFamily:Oswald;fontWeight:bold',fontSize:function(){return Math.round(32*brd1.canvasWidth/800.)}, fixed:true});
  placeTitle(brd1, 'Tangents of a Circle', '(Number of Tangents to a Circle)');
  placeLogo(brd1);
  var reload = placeShuffle(brd1);
  var test = placeTest(brd1);
  var centerx = 0;
  var centery = 0;

  let switchStatus = true;

  //Tape
  var x0_tape = 5;
  var y0_tape = 1;
  var size_tape = 2;


  //Radius
  var radius = brd1.create('slider',[[11,1],[13,1],[0,3,10]], {visible: false, snapToGrid: false ,face:'circle', size:4, strokeWidth: 2, name:'r', strokeColor:'#5B43FF', fillColor: '#5B43FF',  baseline: { strokeColor: '#5B43FF'}, highline: { strokeColor: '#5B43FF'}, postLabel: '', label:{fontSize:function(){return 18*brd1.canvasHeight/800}, cssStyle:'fontFamily:Oswald'}});

  //Circle
  var pt0 = brd1.create('point', [centerx, centery],{face:'o' , name:'O', size:4, strokeColor: '#5B43FF', fillColor: '#5B43FF', fixed:false, visible:true, label:{fontSize:function(){return 18*brd1.canvasHeight/800}, cssStyle:'fontFamily:Oswald'}});
  var c1 = brd1.create('circle', [pt0, [function(){return pt0.X() + radius.Value()}, function(){return pt0.Y()}]], {strokeColor: '#5B43FF', strokeWidth: 4, fixed:true});

  //OP
  var p_P = brd1.create('point', [5,0], {name: 'P', attractors: [c1], attractorDistance: 0.5 , snatchDistance: 1, face:'circle', size:4, label:{offset: [-5, 20], fontSize:function(){return 18*brd1.canvasHeight/800}, cssStyle:'fontFamily:Oswald'}});
  var seg_op = brd1.create('segment', [p_P, pt0], {fixed: true, strokeColor: '#5B43FF', strokeWidth: 3, dash:3});

  var perp1 = brd1.create('perpendicular', [seg_op, p_P], {visible: false, fixed: true, strokeColor: '#FF3B3B', strokeWidth: 3});

  //Tangents
  var p_M = brd1.create('midpoint', [seg_op], {visible: false, name: 'M', face:'circle', size:2, label:{offset: [-5, 20], fontSize:function(){return 18*brd1.canvasHeight/800}, cssStyle:'fontFamily:Oswald'}});
  var c2 = brd1.create('circle', [p_M, p_P], {visible: false, strokeColor: '#5B43FF', strokeWidth: 4, fixed:true});
  var c3 = brd1.create('circle', [p_P, pt0], {visible: false, strokeColor: '#5B43FF', strokeWidth: 4, fixed:true});

  //Intersection
  var p_Q = brd1.create('intersection', [c1, c2, 0], {face:'o' , name:'Q', size:4, strokeColor: '#5B43FF', fillColor: '#5B43FF', fixed:false, visible:true, label:{fontSize:function(){return 18*brd1.canvasHeight/800}, cssStyle:'fontFamily:Oswald'}});
  var p_R = brd1.create('intersection', [c1, c2, 1], {face:'o' , name:'R', size:4, strokeColor: '#5B43FF', fillColor: '#5B43FF', fixed:false, visible:true, label:{fontSize:function(){return 18*brd1.canvasHeight/800}, cssStyle:'fontFamily:Oswald'}});

  var p_Q2 = brd1.create('intersection', [c3, perp1, 0], {face:'o' , name:'Q2', size:4, strokeColor: '#5B43FF', fillColor: '#5B43FF', fixed:false, visible:false, label:{fontSize:function(){return 18*brd1.canvasHeight/800}, cssStyle:'fontFamily:Oswald'}});
  var p_R2 = brd1.create('intersection', [c3, perp1, 1], {face:'o' , name:'R2', size:4, strokeColor: '#5B43FF', fillColor: '#5B43FF', fixed:false, visible:false, label:{fontSize:function(){return 18*brd1.canvasHeight/800}, cssStyle:'fontFamily:Oswald'}});

  //PR and PQ
  var seg_pr = brd1.create('segment', [p_P, p_Q], {fixed: true, strokeColor: '#FF3B3B', strokeWidth: 3});
  var seg_pq = brd1.create('segment', [p_P, p_R], {fixed: true, strokeColor: '#FF3B3B', strokeWidth: 3});
  var seg_qr2 = brd1.create('segment', [p_Q2, p_R2], {fixed: true, strokeColor: '#FF3B3B', strokeWidth: 3, visible: function(){if( seg_op.L() > (radius.Value() - 0.1) && seg_op.L() < (radius.Value() + 0.1) ){return true} else {return false}}});

  //Radius line
  var seg_radius1 = brd1.create('segment', [pt0, p_Q], {fixed: true, strokeColor: '#5B43FF', strokeWidth: 3, dash: 3, visible: true});
  var seg_radius2 = brd1.create('segment', [pt0, p_R], {fixed: true, strokeColor: '#5B43FF', strokeWidth: 3, dash: 3, visible: true});

  //Text
  var txt1 = brd1.create('text', [0, -6,  function(){ if(seg_pr.L() > 0.1){
                                                          return 'Two Tangents';
                                                      }
                                                      else if(seg_op.L() > (radius.Value() - 0.1) && seg_op.L() < (radius.Value() + 0.1)){
                                                          return 'One Tangent';
                                                      }
                                                      else{
                                                          return 'Zero Tangents';
                                                      }
  }],{visible: true, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(18*brd1.canvasWidth/500.)}},);




  //ques.setText();
  //placeMiddleText(brd1, 3.0, 0.5, 'Click on a Slice to Select/Deselect it');
  /////////////////////////////////////////////////////////////////////////////////////////////
  //brd1.create('text', [()=>6+2.75*Math.cos(0.5*type1*2*Math.PI/(type1.valueOf()+type2.valueOf()+type3.valueOf()+type4.valueOf()+type5.valueOf())), ()=>3+2.75*Math.sin(0.5*type1*2*Math.PI/(type1.valueOf()+type2.valueOf()+type3.valueOf()+type4.valueOf()+type5.valueOf())), ()=>'Bulldog ('+type1.valueOf()+'/'+(type1.valueOf()+type2.valueOf()+type3.valueOf()+type4.valueOf()+type5.valueOf())+')'],{display:'internal',anchorX:'middle', fixed:true, CssStyle:'fontFamily:Oswald', fontSize:function(){return Math.round(16*brd1.canvasWidth/800.)}});
  //brd1.create('text', [()=>6+2.75*Math.cos((type1+0.5*type2)*2*Math.PI/(type1.valueOf()+type2.valueOf()+type3.valueOf()+type4.valueOf()+type5.valueOf())), ()=>3+2.75*Math.sin((type1+0.5*type2)*2*Math.PI/(type1.valueOf()+type2.valueOf()+type3.valueOf()+type4.valueOf()+type5.valueOf())), ()=>'Doberman ('+type2.valueOf()+'/'+(type1.valueOf()+type2.valueOf()+type3.valueOf()+type4.valueOf()+type5.valueOf()) +')' ],{display:'internal',anchorX:'middle', fixed:true, CssStyle:'fontFamily:Oswald', fontSize:function(){return Math.round(16*brd1.canvasWidth/800.)}});
  //brd1.create('text', [()=>6+2.75*Math.cos((type1+type2+0.5*type3)*2*Math.PI/(type1.valueOf()+type2.valueOf()+type3.valueOf()+type4.valueOf()+type5.valueOf())), ()=>3+2.75*Math.sin((type1+type2+0.5*type3)*2*Math.PI/(type1.valueOf()+type2.valueOf()+type3.valueOf()+type4.valueOf()+type5.valueOf())), ()=>'Grehound ('+type3.valueOf()+'/'+(type1.valueOf()+type2.valueOf()+type3.valueOf()+type4.valueOf()+type5.valueOf())+')'],{display:'internal',anchorX:'middle', fixed:true, CssStyle:'fontFamily:Oswald', fontSize:function(){return Math.round(16*brd1.canvasWidth/800.)}});
  //brd1.create('text', [()=>6+2.75*Math.cos((type1+type2+type3+0.5*type4)*2*Math.PI/(type1.valueOf()+type2.valueOf()+type3.valueOf()+type4.valueOf()+type5.valueOf())), ()=>3+2.75*Math.sin((type1+type2+type3+0.5*type4)*2*Math.PI/(type1.valueOf()+type2.valueOf()+type3.valueOf()+type4.valueOf()+type5.valueOf())), ()=>'Dalmatian ('+type4.valueOf()+'/'+(type1.valueOf()+type2.valueOf()+type3.valueOf()+type4.valueOf()+type5.valueOf())+')'],{display:'internal',anchorX:'middle', fixed:true, CssStyle:'fontFamily:Oswald', fontSize:function(){return Math.round(16*brd1.canvasWidth/800.)}});
  //brd1.create('text', [()=>6+2.75*Math.cos((type1+type2+type3+type4+0.5*type5)*2*Math.PI/(type1.valueOf()+type2.valueOf()+type3.valueOf()+type4.valueOf()+type5.valueOf())), ()=>3+2.75*Math.sin((type1+type2+type3+type4+0.5*type5)*2*Math.PI/(type1.valueOf()+type2.valueOf()+type3.valueOf()+type4.valueOf()+type5.valueOf())), ()=>'Shar-Pie ('+type5.valueOf()+'/'+(type1.valueOf()+type2.valueOf()+type3.valueOf()+type4.valueOf()+type5.valueOf()) +')'],{display:'internal',anchorX:'middle', fixed:true, CssStyle:'fontFamily:Oswald', fontSize:function(){return Math.round(16*brd1.canvasWidth/800.)}});
//
/////////////////////
/*var sect=[];
var ini = function(){
brd1.removeObject(sect,true);
}
/////////////////
 var status =[];
 var fun = function(){
 for(let i=0; i<lenArr[k]; i++)
 {
   sect[i] =brd1.create('sector', [[3,4],
    [3+2*Math.cos((i+1)*2*Math.PI/Math.max(lenArr[k],1)), 4+2*Math.sin((i+1)*2*Math.PI/Math.max(lenArr[k], 1))],
    [3+2*Math.cos((i+2)*2*Math.PI/Math.max(lenArr[k],1)), 4+2*Math.sin((i+2)*2*Math.PI/Math.max(lenArr[k], 1))]],
   {strokeColor:'black', strokeWidth:1, fillOpacity:0.});
   status[i] = 0;
   sect[i].setAttribute({dash:2, center:{visible:false}, radiusPoint:{visible:false}, anglePoint:{visible:false}});
 }
};
 var test = function()
 { let total=0;
   for(let i=0; i<lenArr[k]; i++)
   {
     total = total + Math.abs(Math.sin(status[i]*Math.PI/2));
   }
   return total;
 }
ini(); fun();

brd1.on('up', function(evt)
{
  let coords = brd1.getMousePosition(evt);
  for(let i=0; i<lenArr[k]; i++)
  {
    if(sect[i].hasPointSector(coords[0], coords[1])==true)
    { status[i] +=1;
      right.setAttribute({visible:false});
      wrong.setAttribute({visible:false});
      sect[i].setAttribute({fillOpacity:Math.abs(Math.sin(status[i]*Math.PI/2)), fillColor:'OldLace'});
    }
  }
);
*/
//brd1.create('text', [6, 6, function(){return coords[0]}]);
 //num.on('down', function(){i=0; ini();fun();brd1.update()});
 //den.on('down', function(){i=0; ini();fun();brd1.update()});
 /////////////////////////////////////////////////////
 /*let magicGraph = document.querySelector("#jxgbox1");
 let inputFields = magicGraph.querySelectorAll("input");
 var onEachPress = function(event) { i=0; ini(); sect=[]; fun();}
    inputFields.forEach(function(field) {
    field.addEventListener('input', onEachPress);});*/
/*  brd1.create('segment', [[3,4], [()=>3+2*Math.cos(2*Math.PI/(den.Value())), ()=>4+2*Math.sin(2*Math.PI/(den.Value()))]],
  {strokeColor:'black', strokeWidth:1, dash:2});
  brd1.create('segment', [[3,4], [()=>3+2*Math.cos(4*Math.PI/(den.Value())), ()=>4+2*Math.sin(4*Math.PI/(den.Value()))]],
  {strokeColor:'black', strokeWidth:1, dash:2});
  brd1.create('segment', [[3,4], [()=>3+2*Math.cos(6*Math.PI/(den.Value())), ()=>4+2*Math.sin(6*Math.PI/(den.Value()))]],
  {strokeColor:'black', strokeWidth:1, dash:2});
  brd1.create('segment', [[3,4], [()=>3+2*Math.cos(8*Math.PI/(den.Value())), ()=>4+2*Math.sin(8*Math.PI/(den.Value()))]],
  {strokeColor:'black', strokeWidth:1, dash:2});
  brd1.create('segment', [[3,4], [()=>3+2*Math.cos(10*Math.PI/(den.Value())), ()=>4+2*Math.sin(10*Math.PI/(den.Value()))]],
  {strokeColor:'black', strokeWidth:1, dash:2});
  brd1.create('segment', [[3,4], [()=>3+2*Math.cos(12*Math.PI/(den.Value())), ()=>4+2*Math.sin(12*Math.PI/(den.Value()))]],
  {strokeColor:'black', strokeWidth:1, dash:2});*/
//
//reload.on('down', function(){ini();type1=Math.round(Math.random()*3)+1; type2=Math.round(Math.random()*4)+1; type3=Math.round(Math.random()*4)+1;type4=Math.round(Math.random()*2)+1;type5=Math.round(Math.random()*3)+1;
//   i=1;j=1;k=1;l=1;m=1;});
//brd1.unsuspendUpdate();
},
}
export default Boxes;
